import { render, staticRenderFns } from "./palletAdd.vue?vue&type=template&id=39e9f656&scoped=true"
import script from "./palletAdd.vue?vue&type=script&lang=js"
export * from "./palletAdd.vue?vue&type=script&lang=js"
import style0 from "./palletAdd.vue?vue&type=style&index=0&id=39e9f656&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e9f656",
  null
  
)

export default component.exports